export default "__VITE_ASSET__BxiDGvPI__"